import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "error-role"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "/static/toc/mobile/img/logo_danxiaoer_1.png"
    }
  })]), _c('div', [_c('p', {
    staticClass: "version"
  }, [_vm._v(i18n.tc("36"))]), _c('p', {
    staticClass: "label"
  }, [_vm._v(i18n.tc("37"))])]), _c('div', {
    staticClass: "title"
  }, [_vm._v(i18n.tc("38"))]), _c('div', {
    staticClass: "description"
  }, [_c('p', [_vm._v(i18n.tc("39"))])])]);
}];
export { render, staticRenderFns };